import Minigames, { MG_TYPES } from "@/js/Minigames/Minigames";
import { useEffect, useMemo, useState } from 'react';
import ConnectionLink from "./ConnectionLink/ConnectionLink";
import DragDrop from "./DragDrop/DragDrop";
import Qcm from "./Qcm/Qcm";
import Sokoban from "./Sokoban/Sokoban";

import Popup from '@/components/shared/Popup/Popup';
import { observer } from "mobx-react-lite";
import SoundPlayer from "react-sdk/SoundPlayer";
import Labyrinth from "./Labyrinth/Labyrinth";
import classes from './PopupMinigameSequence.module.css';
import ReordonnerGame from "./ReordonnerPopup/ReordonnerPopup";
import Swipe from "./SwipePopup/Swipe";
import Activity from "./Activity/Activity";

const haxeGame = [MG_TYPES.SOKOBAN, MG_TYPES.LABYRINTH, MG_TYPES.CONNECTION_LINK]

const PopupMinigameSequence = () => {

  let mg = Minigames.current
  let elementRef = mg?.elementRef

  function onFinished(score) {
    Minigames.stop(score)
  }

  useEffect(() => {
    SoundPlayer.playSound("music_MG")
  }, []);


  return (
    <Popup className={classes.PopupMinigameSequence} onClose={ () => {
      onFinished(mg?.skipScore)
    } }>

      {/* {!haxeGame.includes(mg.type) && <div className={classes.bgOverlay} />} */}

      {/* {ftue_avail &&
        <Button icon={<FaQuestion />} className={classes.ftue_btn} onClick={showFtue} />} */}

      {elementRef !== null && mg.type === MG_TYPES.QUIZ &&
        <Activity
          key={elementRef.ID}
          instance={elementRef}
          GameComponent={Qcm}
          onFinished={onFinished} />}

      {elementRef !== null && mg.type === MG_TYPES.DRAGDROP &&
        <Activity
          key={elementRef.ID}
          instance={elementRef}
          GameComponent={DragDrop}
          onFinished={onFinished} />}

      {/* {elementRef !== null && mg.type === MG_TYPES.DRAGDROP_IMAGE &&
        <Activity
          key={elementRef.ID}
          instance={elementRef}
          showMediaInTitle={false}
          GameComponent={DragDropImage}
          onFinished={onFinished} />} */}

      {elementRef !== null && mg.type === MG_TYPES.SWIPE &&
        <Activity
          key={elementRef.ID}
          instance={elementRef}
          GameComponent={Swipe}
          onFinished={onFinished} />}


      {elementRef !== null && mg.type === MG_TYPES.REORDER &&
       <Activity
          key={elementRef.ID}
          instance={elementRef}
          GameComponent={ReordonnerGame}
          onFinished={onFinished} />
      }


      {mg.type === MG_TYPES.SOKOBAN &&
        <Sokoban
          level={1}
          onFinished={onFinished}
        />}

      {mg.type === MG_TYPES.LABYRINTH &&
        <Labyrinth
          level={parseInt(mg.elementRef) ?? 0}
          onFinished={onFinished}
        />}


      {mg.type === MG_TYPES.CONNECTION_LINK &&
        <ConnectionLink
          level={"connection_puzzle"}
          onFinished={onFinished}
        />}

      {/* {!haxeGame.includes(mg.type) &&
        // les jeux haxe gère l'affiche de leur score eux même
        <div className={classes.score}>
          <div className={classes.score_title}>{Texts.get("score-block-title")}</div>
          <span>{score}</span>
        </div>
      } */}
    </Popup>
  )
}

export default observer(PopupMinigameSequence)
